// Empyreum: legacy tab compatibility for other product templates.
(function(){
  'use strict';
  function setupTabs(){
    document.querySelectorAll('.tabs').forEach(function(group){
      var tabs=Array.from(group.querySelectorAll('.tab'));
      if(!tabs.length)return;
      var panels=tabs.map(function(tab){return document.getElementById(tab.getAttribute('data-tab'));});
      tabs.forEach(function(tab,index){
        tab.addEventListener('click',function(){
          tabs.forEach(function(t){t.classList.remove('active');});
          panels.forEach(function(p){if(p)p.classList.remove('active');});
          tab.classList.add('active');
          if(panels[index])panels[index].classList.add('active');
        });
      });
      var active=tabs.findIndex(function(tab){return tab.classList.contains('active');});
      if(active<0)active=0;
      tabs[active].classList.add('active');
      if(panels[active])panels[active].classList.add('active');
    });
  }
  function setupReadMore(){
    var button=document.getElementById('read-more-btn');
    var wrapper=document.querySelector('.description-wrapper');
    var overlay=document.querySelector('.fade-overlay');
    if(!button||!wrapper||!overlay)return;
    button.addEventListener('click',function(){
      var expand=!wrapper.classList.contains('expanded');
      wrapper.classList.toggle('expanded',expand);
      wrapper.style.maxHeight=expand?wrapper.scrollHeight+'px':'150px';
      overlay.style.display=expand?'none':'block';
      button.textContent=expand?'Bezárás':'Bővebben';
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setupTabs();setupReadMore();});
  else{setupTabs();setupReadMore();}
})();